import { render, staticRenderFns } from "./RefStatusListAddNew.vue?vue&type=template&id=67317b8e"
import script from "./RefStatusListAddNew.vue?vue&type=script&lang=js"
export * from "./RefStatusListAddNew.vue?vue&type=script&lang=js"
import style0 from "./RefStatusListAddNew.vue?vue&type=style&index=0&id=67317b8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports